module.exports = __webpack_public_path__ + "images/banksy-c95cf225b9d635ff54d3855d0909e12e.png";